export default __webpack_public_path__ + "static/media/active-lock-icon.e3bfadc5.svg";